/* Rico Perez shop: live search, category chips, sort, filters, quick add. */
(function () {
  'use strict';
  var root = document.querySelector('[data-rp-shop]');
  if (!root) return;

  var d = root.dataset;
  var cfg = {
    handle: d.handle || 'all',
    pageSize: parseInt(d.pageSize, 10) || 20,
    newDays: parseInt(d.newDays, 10) || 0,
    currency: d.currency || 'USD',
    addLabel: d.addLabel || 'Add to cart',
    cartUrl: d.cartUrl || '/cart'
  };
  var $ = function (s) { return root.querySelector(s); };
  var els = {
    grid: $('[data-grid]'), chips: $('[data-chips]'), search: $('[data-search]'),
    sort: $('[data-sort]'), stock: $('[data-stock]'), price: $('[data-price]'),
    count: $('[data-count]'), more: $('[data-more]'), empty: $('[data-empty]'),
    clear: root.querySelectorAll('[data-clear]'), ssr: $('[data-ssr]'), toast: $('[data-toast]'),
    active: $('[data-active]')
  };

  var cache = {};
  var all = [];
  var state = { cat: cfg.handle, q: '', sort: 'featured', stock: false, price: 'any', shown: cfg.pageSize };
  var chipsDef = [];
  try { chipsDef = JSON.parse(($('[data-chip-json]') || {}).textContent || '[]'); } catch (e) { chipsDef = []; }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(v) {
    var n = parseFloat(v);
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cfg.currency }).format(n); }
    catch (e) { return '$' + n.toFixed(2); }
  }
  function img(u, w) { return u ? u.replace(/(\.[a-zA-Z]+)(\?|$)/, '_' + w + 'x$1$2') : ''; }

  function load(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/collections/' + handle + '/products.json?limit=250', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) {
        var list = (j.products || []).map(function (p, i) {
          var vs = p.variants || [];
          var av = vs.filter(function (v) { return v.available; });
          var base = av[0] || vs[0] || {};
          var prices = vs.map(function (v) { return parseFloat(v.price); });
          var cmp = parseFloat(base.compare_at_price) || 0;
          var pr = parseFloat(base.price) || 0;
          return {
            id: p.id, i: i, title: p.title, handle: p.handle, type: p.product_type || '', vendor: p.vendor || '',
            tags: (p.tags || []).join(' ').toLowerCase(),
            img: p.images && p.images[0] ? p.images[0].src : '',
            img2: p.images && p.images[1] ? p.images[1].src : '',
            variants: vs, available: av.length > 0,
            price: pr, min: prices.length ? Math.min.apply(null, prices) : pr,
            compare: cmp > pr ? cmp : 0,
            created: Date.parse(p.published_at || p.created_at) || 0
          };
        });
        cache[handle] = list;
        return list;
      })
      .catch(function () { return []; });
  }

  function matches(p) {
    if (state.q) {
      var hay = (p.title + ' ' + p.type + ' ' + p.vendor + ' ' + p.tags).toLowerCase();
      var parts = state.q.toLowerCase().split(/\s+/).filter(Boolean);
      for (var k = 0; k < parts.length; k++) { if (hay.indexOf(parts[k]) < 0) return false; }
    }
    if (state.stock && !p.available) return false;
    if (state.price === 'u25' && !(p.min < 25)) return false;
    if (state.price === '25-50' && !(p.min >= 25 && p.min < 50)) return false;
    if (state.price === 'o50' && !(p.min >= 50)) return false;
    return true;
  }

  function sorted(list) {
    var a = list.slice();
    var s = state.sort;
    if (s === 'low') a.sort(function (x, y) { return x.min - y.min; });
    else if (s === 'high') a.sort(function (x, y) { return y.min - x.min; });
    else if (s === 'az') a.sort(function (x, y) { return x.title.localeCompare(y.title); });
    else if (s === 'new') a.sort(function (x, y) { return y.created - x.created; });
    else a.sort(function (x, y) { return x.i - y.i; });
    return a;
  }

  function card(p, idx) {
    var badges = '';
    if (!p.available) badges += '<span class="rp-shop__badge rp-shop__badge--out">Sold out</span>';
    else if (p.compare) badges += '<span class="rp-shop__badge rp-shop__badge--sale">Save ' + Math.round((1 - p.price / p.compare) * 100) + '%</span>';
    else if (cfg.newDays && p.created && (Date.now() - p.created) < cfg.newDays * 86400000) badges += '<span class="rp-shop__badge">New</span>';

    var multi = p.variants.length > 1;
    var opts = '';
    if (multi) {
      opts = '<select class="rp-shop__opt" aria-label="Option for ' + esc(p.title) + '">' + p.variants.map(function (v) {
        return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.title) + (v.available ? '' : ' (sold out)') + '</option>';
      }).join('') + '</select>';
    }
    var first = (p.variants.filter(function (v) { return v.available; })[0] || p.variants[0] || {}).id;
    var priceHtml = (multi && p.min !== p.price ? 'From ' : '') + '<strong>' + money(p.available ? p.price : p.min) + '</strong>' +
      (p.compare ? ' <s>' + money(p.compare) + '</s>' : '');
    return '<article class="rp-shop__card" style="--d:' + Math.min(idx, 12) * 40 + 'ms" data-vid="' + first + '">' +
      '<a class="rp-shop__media" href="/products/' + esc(p.handle) + '" aria-label="' + esc(p.title) + '">' + badges +
      (p.img ? '<img class="rp-shop__img" loading="lazy" alt="' + esc(p.title) + '" src="' + esc(img(p.img, 600)) + '">' : '') +
      (p.img2 ? '<img class="rp-shop__img rp-shop__img--alt" loading="lazy" alt="" src="' + esc(img(p.img2, 600)) + '">' : '') + '</a>' +
      '<div class="rp-shop__body"><a class="rp-shop__name" href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a>' +
      '<div class="rp-shop__price">' + priceHtml + '</div>' + opts +
      '<button type="button" class="rp-shop__add"' + (p.available ? '' : ' disabled') + ' data-add>' + (p.available ? esc(cfg.addLabel) : 'Sold out') + '</button></div></article>';
  }

  function render() {
    var list = sorted(all.filter(matches));
    var slice = list.slice(0, state.shown);
    els.grid.innerHTML = slice.map(card).join('');
    els.grid.setAttribute('aria-busy', 'false');
    els.count.textContent = list.length + (list.length === 1 ? ' product' : ' products');
    els.empty.hidden = list.length > 0;
    var left = list.length - slice.length;
    els.more.hidden = left <= 0;
    els.more.textContent = 'Show ' + Math.min(left, cfg.pageSize) + ' more  ·  ' + left + ' left';
    var on = state.q || state.stock || state.price !== 'any';
    els.active.hidden = !on;
    root.classList.toggle('is-loaded', true);
    if (els.ssr) els.ssr.hidden = true;
    sync();
  }

  function sync() {
    try {
      var u = new URL(location.href);
      ['q', 'sort', 'cat', 'stock', 'price'].forEach(function (k) { u.searchParams.delete(k); });
      if (state.q) u.searchParams.set('q', state.q);
      if (state.sort !== 'featured') u.searchParams.set('sort', state.sort);
      if (state.cat !== cfg.handle) u.searchParams.set('cat', state.cat);
      if (state.stock) u.searchParams.set('stock', '1');
      if (state.price !== 'any') u.searchParams.set('price', state.price);
      history.replaceState(null, '', u.toString());
    } catch (e) { /* ignore */ }
  }

  function setCat(handle) {
    state.cat = handle;
    state.shown = cfg.pageSize;
    els.grid.setAttribute('aria-busy', 'true');
    els.chips.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.cat === handle)); });
    return load(handle).then(function (list) { all = list; render(); });
  }

  function buildChips() {
    var html = '<button type="button" class="rp-shop__chip" data-cat="' + esc(cfg.handle) + '" aria-pressed="true">All</button>';
    chipsDef.forEach(function (c) { html += '<button type="button" class="rp-shop__chip" data-cat="' + esc(c.handle) + '" aria-pressed="false">' + esc(c.label) + '</button>'; });
    els.chips.innerHTML = html;
    els.chips.hidden = chipsDef.length === 0;
  }

  function autoChips() {
    if (chipsDef.length) return;
    var types = {};
    all.forEach(function (p) { if (p.type) types[p.type] = (types[p.type] || 0) + 1; });
    var keys = Object.keys(types);
    if (keys.length < 2) return;
    els.chips.innerHTML = '<button type="button" class="rp-shop__chip" data-type="" aria-pressed="true">All</button>' + keys.sort().map(function (k) {
      return '<button type="button" class="rp-shop__chip" data-type="' + esc(k) + '" aria-pressed="false">' + esc(k) + '</button>';
    }).join('');
    els.chips.hidden = false;
    els.chips.dataset.mode = 'type';
  }

  var typeFilter = '';
  var origMatches = matches;
  matches = function (p) { return (!typeFilter || p.type === typeFilter) && origMatches(p); };

  els.chips.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b) return;
    if (els.chips.dataset.mode === 'type') {
      typeFilter = b.dataset.type || '';
      els.chips.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      state.shown = cfg.pageSize; render();
    } else { setCat(b.dataset.cat); }
  });

  var timer;
  els.search.addEventListener('input', function () {
    clearTimeout(timer);
    timer = setTimeout(function () { state.q = els.search.value.trim(); state.shown = cfg.pageSize; render(); }, 160);
  });
  els.sort.addEventListener('change', function () { state.sort = els.sort.value; render(); });
  els.stock.addEventListener('change', function () { state.stock = els.stock.checked; state.shown = cfg.pageSize; render(); });
  els.price.addEventListener('change', function () { state.price = els.price.value; state.shown = cfg.pageSize; render(); });
  els.more.addEventListener('click', function () { state.shown += cfg.pageSize; render(); });
  Array.prototype.forEach.call(els.clear, function (b) {
    b.addEventListener('click', function () {
      state.q = ''; state.stock = false; state.price = 'any'; typeFilter = '';
      els.search.value = ''; els.stock.checked = false; els.price.value = 'any';
      els.chips.querySelectorAll('button').forEach(function (x, i) { if (els.chips.dataset.mode === 'type') x.setAttribute('aria-pressed', String(i === 0)); });
      state.shown = cfg.pageSize; render();
    });
  });

  function toast(msg, withLink) {
    els.toast.innerHTML = '<span>' + esc(msg) + '</span>' + (withLink ? ' <a href="' + esc(cfg.cartUrl) + '">View cart</a>' : '');
    els.toast.classList.add('is-on');
    clearTimeout(toast.t);
    toast.t = setTimeout(function () { els.toast.classList.remove('is-on'); }, 3200);
  }

  function bumpCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], [data-cart-count]').forEach(function (n) { n.textContent = c.item_count; });
      document.dispatchEvent(new CustomEvent('rp:cart-updated', { detail: c }));
    }).catch(function () {});
  }

  els.grid.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add]');
    if (!btn) return;
    var cardEl = btn.closest('.rp-shop__card');
    var sel = cardEl.querySelector('.rp-shop__opt');
    var vid = sel ? sel.value : cardEl.dataset.vid;
    var name = cardEl.querySelector('.rp-shop__name').textContent;
    btn.disabled = true; var old = btn.textContent; btn.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('x'); return r.json(); })
      .then(function () { btn.textContent = 'Added ✓'; btn.classList.add('is-done'); toast(name + ' added', true); return bumpCart(); })
      .catch(function () { btn.textContent = 'Try again'; })
      .then(function () { setTimeout(function () { btn.disabled = false; btn.textContent = old; btn.classList.remove('is-done'); }, 1600); });
  });

  // ---- init (restore state from the URL) ----
  buildChips();
  var qs = new URLSearchParams(location.search);
  if (qs.get('q')) { state.q = qs.get('q'); els.search.value = state.q; }
  if (qs.get('sort')) { state.sort = qs.get('sort'); els.sort.value = state.sort; }
  if (qs.get('stock')) { state.stock = true; els.stock.checked = true; }
  if (qs.get('price')) { state.price = qs.get('price'); els.price.value = state.price; }
  var startCat = qs.get('cat');
  var ok = startCat && chipsDef.some(function (c) { return c.handle === startCat; });
  load(ok ? startCat : cfg.handle).then(function (list) {
    all = list; state.cat = ok ? startCat : cfg.handle;
    els.chips.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.cat === state.cat)); });
    if (!ok) autoChips();
    render();
  });
})();
